import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './ProductAnswerUpvote.scss';

const ProductAnswerUpvote = ({ handleUpvote, upvoted = false }) => {

	const [ answerUpvoted, setAnswerUpvoted ] = useState(upvoted);

	return (
		<div className="ProductAnswerUpvote">
			<button
				type="button"
				aria-label={answerUpvoted ? 'Answer upvoted' : 'Upvote answer'}
				disabled={answerUpvoted}
				onClick={() => {

					setAnswerUpvoted(true);
					handleUpvote();

				}}
			>
				{answerUpvoted ? <span className="lpIcon-favoriteselected" /> : <span className="lpIcon-favorite" />}
			</button>
		</div>
	);

};

ProductAnswerUpvote.propTypes = {
	handleUpvote: PropTypes.func.isRequired,
	upvoted: PropTypes.bool
};

export default ProductAnswerUpvote;
